export default __webpack_public_path__ + "static/scroll_phone_4-090c4270450445f42a34cb8d1baced8e.png";